export const CREATE_NOTIFICATION = "CREATE_NOTIFICATION";
export const RETRIEVE_NOTIFICATION = "RETRIEVE_NOTIFICATION";
export const RETRIEVESINGLE_NOTIFICATION = "RETRIEVESINGLE_NOTIFICATION";
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";


